module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/4@2x_c54b346c29b2f7471a9ca9d39efe23ee.png";